function formatTimeValue(timeValue: number): string {
  const hour = Math.floor(timeValue);
  const minute = Math.round((timeValue - hour) * 60);

  const hourStr = hour.toString();

  if (minute === 0) {
    return hourStr;
  }

  const minuteStr = minute.toString().padStart(2, '0');
  return `${hourStr}:${minuteStr}`;
}

export const hourToString = (hour: number): string => {
  const tv = formatTimeValue(hour);

  if (hour === 0 || hour === 24) {
    return '12 am';
  }
  if (hour === 12) {
    return `${tv} pm`;
  }
  if (hour < 12) {
    return `${tv} am`;
  }
  return `${formatTimeValue(hour - 12)} pm`;
};

export function describeTimeRange(timeValues: number[], inverted: boolean): string {
  if (timeValues[0] === 0 && timeValues[1] === 24) {
    return 'All day';
  }

  const start = formatTimeValue(timeValues[0]);
  const end = formatTimeValue(timeValues[1]);

  if (inverted) {
    return `Outside ${end} - ${start}`;
  }

  return `${start} - ${end}`;
}
